import type { TabsTemplateProps } from './index';

export default function TabsTemplate({
  label,
  triggers,
  active,
  onActivate,
  onKeyDown,
}: TabsTemplateProps) @{
  <>
    <div class="crown-tabs-list" role="tablist" aria-label={label}>
      @for (const tab of triggers(); key tab.id) {
        <button
          type="button"
          role="tab"
          class="crown-tabs-trigger"
          class:is-active={() => active.get() === tab.id}
          id={`tab-trigger-${tab.id}`}
          data-tab-id={tab.id}
          aria-controls={`tab-panel-${tab.id}`}
          aria-selected={() => active.get() === tab.id}
          tabindex={() => (active.get() === tab.id ? '0' : '-1')}
          disabled={tab.disabled}
          onClick={() => onActivate(tab.id)}
          onKeyDown={(event) => onKeyDown(event, tab.id)}
        >
          <span>{tab.label}</span>
          @if (tab.badge !== undefined) {
            <span class="tab-badge">{tab.badge}</span>
          }
        </button>
      }
    </div>
  </>
}
